var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-preview-view" },
    [
      _c(
        "div",
        { staticClass: "editor-preview-view-container" },
        [
          _vm.model3D
            ? _c("EditorPreview3DView", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.internalValue === "3d",
                    expression: "internalValue === '3d'",
                  },
                ],
                attrs: {
                  "bleed-margin": _vm.bleedMargin,
                  "offering-frame-model": _vm.offeringFrameModel,
                  "offering-model": _vm.offeringModel,
                  "page-model": _vm.pageModel,
                  "page-objects": _vm.pageObjects,
                  value: _vm.model3D,
                },
              })
            : _vm.hasCube
            ? _c("EditorPreviewCubeView", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.internalValue === "3d",
                    expression: "internalValue === '3d'",
                  },
                ],
              })
            : _vm._e(),
          _vm.model2D
            ? _c("EditorPreview2DView", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.internalValue === "2d",
                    expression: "internalValue === '2d'",
                  },
                ],
                attrs: {
                  "bleed-margin": _vm.bleedMargin,
                  "offering-frame-model": _vm.offeringFrameModel,
                  "offering-model": _vm.offeringModel,
                  "page-model": _vm.pageModel,
                  "page-objects": _vm.pageObjects,
                  value: _vm.model2D,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.hasMultipleModels
        ? _c(
            "ButtonToggleGroupComponent",
            {
              attrs: { value: _vm.internalValue },
              on: { change: _vm.onPreviewModeChange },
            },
            [
              _c(
                "ButtonToggleComponent",
                { attrs: { small: true, name: "preview-mode", value: "3d" } },
                [_vm._v(_vm._s(_vm.$t("views.editorPreview.buttons.3d")))]
              ),
              _c(
                "ButtonToggleComponent",
                { attrs: { small: true, name: "preview-mode", value: "2d" } },
                [_vm._v(_vm._s(_vm.$t("views.editorPreview.buttons.2d")))]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }